module.exports = "img/13.ba3d34.webp";